import React, { Component } from 'react'
import { connect } from 'react-redux'
import * as actions from '../../../Cereal/actions'
import { Field } from 'redux-form'
import { Row, Col } from 'react-bootstrap'
import { renderSelectField } from '../../fieldRenderers'
import CerealDropdown from './CerealDropdown'

class CerealVariedadDropdown extends Component {
  constructor (props) {
    super(props)
    this.renderVariedades =
      this.renderVariedades.bind(this)
    this.onSelect = this.onSelect.bind(this)
    this.getVariedadField = this.getVariedadField.bind(this)
  }

  onSelect (e) { }

  renderVariedades () {
    const {
      cerealVariedades
    } = this.props

    return cerealVariedades.map(cerealVeriedad => {
      return (
        <option
          value={cerealVeriedad.nombreCortoVariedad}
          key={cerealVeriedad.nombreCortoVariedad}
        >
          {cerealVeriedad.nombre}
        </option>
      )
    })
  };

  getVariedadField () {
    const {
      isRequesting,
      disabledVariedad
    } = this.props

    return (
      <Field
        onChange={this.onSelect}
        name='cerealVariedad'
        label='Variedad'
        disabled={disabledVariedad}
        component={renderSelectField}>
        {!isRequesting ? this.renderVariedades() : null}
      </Field>
    )
  };

  render () {
    const {
      disabledCereal,
      required = false,
      cerealInicial = null,
      cerealesDeshabilitados = false,
      fieldNameCereal = null
    } = this.props

    return (
      <Row>
        <Col md={6}>
          <CerealDropdown
            disabled={disabledCereal}
            required={required}
            cerealInicial={cerealInicial}
            cerealesDeshabilitados={cerealesDeshabilitados}
            textLabel={this.props.textLabel || null}
            textPlaceHolder={this.props.textPlaceHolder || null}
            fieldName={fieldNameCereal}
          />
        </Col>
        <Col md={6}>
          {this.getVariedadField()}
        </Col>
      </Row>
    )
  }
}

const mapStateToProps = (state) => ({
  isRequesting: state.cereal.isRequestingCrealVariedades,
  cerealVariedades: state.cereal.cerealVariedades,
  selectedCerealEspecie: state.cereal.selectedCerealEspecie
})

const withRedux = connect(mapStateToProps, actions)

export default withRedux(CerealVariedadDropdown)
